import type { Styles } from 'react-modal'

import './style.css'

export const MODAL_WIDTH = {
  smallest: 425,
  smaller: 540,
  small: 600,
  normal: 720,
  medium: 800,
  large: 960,
  larger: 1200,
}

export const MODAL_FULLSCREEN_STYLE: Styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 4,
  },
  content: {
    position: 'relative',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    padding: 0,
    width: '100%',
    height: '100%',
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch',
    zIndex: 5,
    border: 'none',
    borderRadius: '0px',
    outline: 'none',
  },
}

export const MODAL_DEFAULT_CLASS =
  'background-shade-100 shadow-large electron-no-drag-region'
/*
  In case modal is over the breadcrumb which is a drag region, we need to specifically disable dragging,
  Electron doesn't care about elements z-indexes.
  https://github.com/electron/electron/issues/11768#issuecomment-455683581
*/
export const MODAL_DEFAULT_STYLE: Styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'scroll',
    zIndex: 4,
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    borderRadius: '8px',
    position: 'relative',
    padding: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5,
    border: 'none',
    WebkitOverflowScrolling: 'touch',
    overflow: 'visible',
    outline: 'none',
  },
}
